import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: { escapeValue: false },
  resources: {
    'pt-BR': {
      translation: {
        common: {
          loading: 'Carregando',
          save: 'Salvar',
          cancel: 'Cancelar',
          search: 'Buscar',
          create: 'Criar',
          edit: 'Editar',
          delete: 'Excluir',
          actions: 'Ações',
          noResults: 'Nenhum resultado encontrado',
        },
      },
    },
  },
})

export default i18n
